/*
  Helper function to use with stylesObject and pass result into className.
  If passed in style is not present on the predefined object - returns value under "DEFAULT" key of the provided object,
  otherwise will return passed in style itself.
*/
export const getStyle = (style, object) =>
  Object.values(object).indexOf(style) !== -1 ? style : object.DEFAULT
